module.exports = __webpack_public_path__ + "media/images/pc/brands/tvb/store_kobe-f9bf2180b0d260c907f7451c157f2695.jpg";